import { ref, reactive, onBeforeMount, watch, computed, getCurrentInstance } from "@vue/composition-api";
import useModal from '@/@core/components/base-modal/hooks/useModal'
import useTagList from '@/utils/hooks/useTagList'
import quizListModel from '@/models/survey-quiz/quiz-list'
import router from "@/router";
import store from "@/store";
import useValidationModal from "@/@core/components/base-modal/hooks/useValidationModal";
import usePagination from '@/views/components/pagination/usePagination'
import useFilterHeaderTable from '@/views/components/filter-header-table/useFilterHeaderTable'

export default function usePrivilege() {
    const { openModal, closeModal } = useModal()
    const { fetchTagListData, } = useTagList()
    const { fetchQuizListPermissionModel, updatePermission, fetchQuizDetailModel, CreateUpdateReward, fetchInventoryList: fetchInventoryListModel, fetchEntryInventoryList } = quizListModel()
    const { openErrorModal, openDefaultErrorModal, openSuccessModal } = useValidationModal();
    const { pagination, onPageChange, onFilterEntity } = usePagination()
    const { filters, ordering, onSetValueSearch } = useFilterHeaderTable()
    const vm = getCurrentInstance().proxy;

    const privilegeForm = reactive({
        isComplete: false,
        quizGroupId: null,
        duplicate: [],
        answerSetPoint: 1,
        rewardType: 3,
        isEqual: true,
        minimumCorrect: 0,
        selectInventory: null,
        selectReward: null,
        numberQuiz: null,
        point: 0

    })

    const changeOption = reactive({
        visibility: [{
            label: null,
            point: 1,
            reward: null,
            seq: null
        }],

        respRewardList: [],
        rewardTypeOption: [
            { item: 3, name: 'ไม่ได้รางวัล' },
            { item: 2, name: 'แต้ม' },
            { item: 1, name: 'ของรางวัล' },
        ],

        inventoryOption: [],
        privilegeInventoryOption: [],
    })

    if (router.currentRoute.query.quizGroupId) {
        privilegeForm.quizGroupId = parseInt(router.currentRoute.query.quizGroupId)

    } else {
        privilegeForm.quizGroupId = parseInt(router.currentRoute.params.ref)
    }

    //option select
    const tagOption = reactive({
        visibilityTagOption: [],
        quizzerOption: []
    });

    const dataModal = reactive({
        headerName: "",
        isTypeReward: "",
        formData: {},
        selectMasterInventory: "",
        selectReward: "",

    })

    const dataTag = reactive({
        payload: [],
    });

    const modalType = reactive({
        changePermission: false,
        setPoint: false,
    })

    const onOpenModalChangePermission = () => {
        modalType.changePermission = true
        openModal()
    }

    const onCloseModalChangePermission = () => {
        closeModal()
        modalType.changePermission = false
    }

    const onOpenModalSetPoint = () => {
        dataModal.isTypeReward = privilegeForm.rewardType
        dataModal.formData = privilegeForm
        modalType.setPoint = true
        fetchQuizListPermission()
        openModal()

    }

    const onCloseModalSetPoint = () => {
        closeModal()
        modalType.setPoint = false
    }

    const updateNumPoint = (number) => {
        privilegeForm.point = number;
    };

    const updateMinimumCorrect = (number) => {
        privilegeForm.minimumCorrect = number;
    };


    // apply set point
    const onSubmitFormSetPoint = (dataArr, dataForm) => {
        onCloseModalSetPoint()
        dataTag.payload = dataArr
        privilegeForm.selectInventory = dataForm.formData.selectInventory

    }

    //update point
    const updatePointModal = (number, i) => {
        changeOption.visibility.map((o, index) => {
            if (privilegeForm.isEqual == false) {
                if (i == index) {
                    o.point = number
                }
            } else {
                o.point = number
            }

        })
    }

    const fetchTag = () => {
        tagOption.visibilityTagOption = fetchTagListData()
    }

    // apply permission
    const onSubmitFormChangePermission = (dataForm, type) => {
        window.$loading(true)

        const visibility = dataForm.visibility
        const quizzer = dataForm.quizzer

        const arrVisibility = visibility.map((e) => ({
            Tag_Name: e,

        }))
        const arrTag_Quizzer = quizzer.map((e) => ({
            Tag_Name: e,
        }))

        updatePermission.payload.GroupId = dataForm.quizGroupId
        updatePermission.payload.Permission_Type = type.value
        updatePermission.payload.IsLimit = dataForm.numberPlayers
        updatePermission.payload.Limit = dataForm.usageLimit != null ? dataForm.usageLimit : 0
        updatePermission.payload.Tag_Quizzer = arrTag_Quizzer
        updatePermission.payload.Tag_Visibility = arrVisibility

        store
            .dispatch('api/apiRequest', updatePermission)
            .then(response => {
                onCloseModalChangePermission();
                fetchQuizDetail()
                fetchQuizListPermission()

            })
            .catch(error => {
                openDefaultErrorModal(error)
            })
            .finally(() => {
                window.$loading(false)
            })
    }

    const fetchQuizDetail = () => {
        window.$loading(true);
        fetchQuizDetailModel.payload.GroupId = privilegeForm.quizGroupId;

        store
            .dispatch("api/apiFormRequest", fetchQuizDetailModel)
            .then((response) => {
                const respQuiz = response.data.resp.list_quiz;
                const respReward = response.data.resp.reward;

                if (respReward) {
                    privilegeForm.rewardType = respReward.quiz_reward_type
                    privilegeForm.isEqual = respReward.isequal

                    privilegeForm.answerSetPoint = respReward.criteria_type

                    if (respReward.minimum_correct) {
                        privilegeForm.minimumCorrect = respReward.minimum_correct
                    }

                    if (privilegeForm.isEqual == true) {
                        privilegeForm.point = respReward.point
                    }

                }

                if (response.data.resp.criteria_reward_list?.length > 0) {
                    const respRewardList = response.data.resp.criteria_reward_list;
                    changeOption.respRewardList = response.data.resp.criteria_reward_list;

                    privilegeForm.selectInventory = respRewardList[0].criteria_reward_list?.inventoryid
                    privilegeForm.selectReward = respRewardList[0].criteria_reward_list?.privilegeid

                    dataTag.payload = respRewardList.map(obj => ({
                        seq: obj.criteria_reward_list.tagid,
                        label: obj.tag_name,
                        point: obj.criteria_reward_list.point,
                        reward: obj.criteria_reward_list.privilegeid,

                    }))
                    fetchInventoryList(privilegeForm.selectInventory)

                } else {
                    fetchInventoryList()
                }
                privilegeForm.isComplete = response.data.resp.is_complete
                privilegeForm.numberQuiz = respQuiz.length
                fetchQuizListPermission()
                fetchTag()

            })
            .catch((err) => {
                openDefaultErrorModal(err);
            })
            .finally(() => {
                window.$loading(false);
            })

    };

    const fetchQuizListPermission = () => {
        window.$loading(true)
        fetchQuizListPermissionModel.payload.GroupId = privilegeForm.quizGroupId;
        store
            .dispatch("api/apiRequest", fetchQuizListPermissionModel)
            .then((response) => {
                const filterTag = response.data.resp.filter((e) => e.quizzer_tagid != null);
                changeOption.visibility = filterTag.map(obj => ({
                    seq: obj.quizzer_tagid,
                    label: obj.quizzer_tag_name,

                }))

                let op = changeOption.visibility.map((e, i) => {
                    let temp = changeOption.respRewardList.find(element => element.criteria_reward_list.tagid == e.seq)
                    if (temp) {
                        e.point = temp.criteria_reward_list.point;
                        if (temp.criteria_reward_list.privilegeid) {
                            e.reward = temp.criteria_reward_list.privilegeid
                        }
                    }

                    return e;
                })
                // tag array
                op.map((e) => {
                    let mapNew = dataTag.payload.find(element => element.seq == e.seq)
                    if (mapNew) {
                        e.point = mapNew.point
                        e.reward = mapNew.reward
                    }

                })
                changeOption.visibility = op

            })
            .catch((error) => {
                openDefaultErrorModal(error);
            })
            .finally(() => {
                window.$loading(false)
            });
    };


    const submitForm = () => {
        window.$loading(true)
        const noTagData = []

        const payload = {
            TagId: null,
            InventoryId: privilegeForm.rewardType != 3 ? privilegeForm.selectInventory : null,
            PrivilegeId: privilegeForm.rewardType != 3 ? privilegeForm.selectReward : null,
            Point: privilegeForm.rewardType != 3 ? privilegeForm.point : 0,
        }

        noTagData.splice(1, 0, payload)

        const payloadPrivilege = {
            GroupId: privilegeForm.quizGroupId,
            Info_Reward: {
                Quiz_Reward_Type: privilegeForm.rewardType,
                IsEqual: privilegeForm.rewardType != 3 ? privilegeForm.isEqual : null,
                Criteria_Type: privilegeForm.rewardType != 3 ? privilegeForm.answerSetPoint : null,
                Minimun_Correct: privilegeForm.rewardType != 3 ? privilegeForm.minimumCorrect : 0,
            },
            Criteria_Reward: changeOption.visibility.length > 0 ? changeOption.visibility.map((item) => ({
                TagId: item.seq,
                InventoryId: privilegeForm.rewardType == 1 ? privilegeForm.selectInventory : null,
                PrivilegeId: privilegeForm.rewardType == 1 ? (privilegeForm.isEqual == false && item.reward ? item.reward : (privilegeForm.selectReward?.value ? privilegeForm.selectReward.value : privilegeForm.selectReward)) : null
                ,
                Point: privilegeForm.rewardType == 2 ? ((privilegeForm.rewardType == 2 && privilegeForm.isEqual == false && item.point) || (privilegeForm.rewardType == 2 && privilegeForm.isEqual == true && privilegeForm.answerSetPoint == 4 && item.point) ? item.point : privilegeForm.point) : 0,
            })) : noTagData

        };

        CreateUpdateReward.payload = payloadPrivilege;
        store
            .dispatch('api/apiRequest', CreateUpdateReward)
            .then(response => {

                openSuccessModal(
                    "ทำรายการสำเร็จ !",
                    null,
                    "ตกลง",
                    () =>

                        router.push("/quiz/quiz-list")
                );
            })
            .catch(error => {
                openDefaultErrorModal(error)
            })
            .finally(() => {
                window.$loading(false)
            })
    };

    const fetchInventoryList = (inventoryId) => {
        window.$loading(true)

        store
            .dispatch('api/apiRequest', fetchInventoryListModel)
            .then(response => {
                changeOption.inventoryOption = response.data.payload.map((e) => ({
                    label: e.name,
                    value: e.inventory_id
                }))

                pagination.rows = response.data.payload.length
                pagination.totalRows = response.data.filtered_record

                if (inventoryId) {
                    fetchPrivilegeInventory(inventoryId)
                }

            })
            .catch(error => {
                openDefaultErrorModal(error)
            })
            .finally(() => {
                window.$loading(false)
            })
    }

    const fetchPrivilegeInventory = (InventoryId, selectIn) => {
        fetchEntryInventoryList.payload.Inventory_Id =
            InventoryId

        store
            .dispatch("api/apiRequest", fetchEntryInventoryList)
            .then((response) => {
                changeOption.privilegeInventoryOption = response.data.payload.map((item) => ({
                    label: item.privilege.name_th,
                    value: item.privilege.privilege_id
                }))

                if (changeOption.privilegeInventoryOption.length == 0) {
                    privilegeForm.selectReward = null
                }

                if (selectIn == false) {
                    privilegeForm.selectReward = null

                    changeOption.visibility.map((obj) => {
                        delete obj.reward
                    })

                }
                pagination.rows = response.data.payload.length;
                pagination.totalRows = response.data.filtered_record;

            })
            .catch((error) => {
                openDefaultErrorModal(error);
            })
            .finally(() => {

            });
    };

    const validatePrivilege = computed(() => {
        if (privilegeForm.rewardType == 1) {
            if (privilegeForm.isEqual == true) {
                return (privilegeForm.selectInventory == null || privilegeForm.selectReward == null) || privilegeForm.minimumCorrect > privilegeForm.numberQuiz || privilegeForm.answerSetPoint == false
            }
            else if (privilegeForm.isEqual == false) {
                return dataTag.payload.length == 0 || privilegeForm.minimumCorrect > privilegeForm.numberQuiz || privilegeForm.answerSetPoint == false
            }

        } else if (privilegeForm.rewardType == 2) {
            if (privilegeForm.isEqual == false) {
                return privilegeForm.minimumCorrect > privilegeForm.numberQuiz || privilegeForm.answerSetPoint == false || dataTag.payload.length == 0
            } else {
                return privilegeForm.minimumCorrect > privilegeForm.numberQuiz || privilegeForm.answerSetPoint == false
            }
        }

    })

    const onChangeReward = (value, idx) => {
        vm.$nextTick(() => {
            let obj = []
            obj = [...changeOption.visibility] //[...] clone
            obj.map((element, index) => {
                if (index == idx) {
                    element.reward = value;
                }
            });
            changeOption.visibility = obj
        })
    }

    const nextPage = () => {
        router.push("/quiz/quiz-list")
    }

    onBeforeMount(() => {
        fetchQuizDetail()

    })

    return {
        privilegeForm,
        changeOption,
        onOpenModalChangePermission,
        onCloseModalChangePermission,
        modalType,
        onOpenModalSetPoint,
        onCloseModalSetPoint,
        dataTag,
        dataModal,
        onSubmitFormChangePermission,
        onSubmitFormSetPoint,
        tagOption,
        updatePointModal,
        submitForm,
        fetchPrivilegeInventory,
        updateNumPoint,
        updateMinimumCorrect,
        onChangeReward,
        validatePrivilege,
        nextPage
    }
}